import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, IconButton, Button, Drawer, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ImageIcon from "@mui/icons-material/Image";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import DescriptionIcon from "@mui/icons-material/Description";
import FetchFiles from "../../../utils/storage/FetchFiles";
import UploadFiles from "../../../utils/storage/UploadFiles";
import Loader from "../../general/Loader";
import { toast } from "react-toastify";
import "./FileUploadSidebar.css";
import { CancelOutlined as CancelIcon } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteFiles from "../../../utils/storage/DeleteFiles";
import useUserDetails from "../../../utils/auth/UserDetails";
const FileUploadSidebar = ({ visible, onHide, chatId, handleFileChangeFromSidebar, setSelectedDocumentIds, extension }) => {
    const [existingFiles, setExistingFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedForUpload, setSelectedForUpload] = useState([]);
    const [uploadStatus, setUploadStatus] = useState({});
    const [uploading, setUploading] = useState(false);
    const [open, setOpen] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);

    const userDetails = useUserDetails();
    console.log(userDetails);

    console.log(extension);
    const canDelete = userDetails?.userId === extension?.userId;


    const fetchExistingFiles = useCallback(async () => {
        if (visible && chatId) {
            setLoading(true);
            try {
                const files = await FetchFiles(chatId, extension.id);

                if (Array.isArray(files)) {
                    setExistingFiles((prevFiles) => {
                        const fileMap = new Map(prevFiles.map(file => [file.file_name, file])); // Preserve existing files
                        files.forEach(file => fileMap.set(file.file_name, file)); // Append new files
                        return Array.from(fileMap.values());
                    });
                } else {
                    console.error("Expected an array but got:", files);
                    setExistingFiles(prevFiles => [...prevFiles]); // Keep previous files if response is invalid
                }
            } catch (error) {
                console.error("Failed to load files:", error);
                setExistingFiles(prevFiles => [...prevFiles]); // Keep previous files on error
            } finally {
                setLoading(false);
            }
        }
    }, [visible, chatId]);

    const handleOpen = (file) => {
        setFileToDelete(file);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFileToDelete(null);
    };



    useEffect(() => {
        fetchExistingFiles();
    }, [fetchExistingFiles]);
console.log(existingFiles);

    const onDrop = useCallback((acceptedFiles) => {
        setSelectedForUpload((prevFiles) => [...prevFiles, ...acceptedFiles]);
    }, []);

    const MAX_TOTAL_FILE_SIZE = parseFloat(process.env.REACT_APP_MAX_TOTAL_FILE_SIZE || '100');
    const MAX_TOTAL_FILE_SIZE_UNIT = process.env.REACT_APP_MAX_TOTAL_FILE_SIZE_UNIT || 'MB';

    let maxSizeInBytes;
    if (MAX_TOTAL_FILE_SIZE_UNIT.toUpperCase() === 'GB') {
        maxSizeInBytes = MAX_TOTAL_FILE_SIZE * 1024 * 1024 * 1024;
    } else if (MAX_TOTAL_FILE_SIZE_UNIT.toUpperCase() === 'MB') {
        maxSizeInBytes = MAX_TOTAL_FILE_SIZE * 1024 * 1024;
    } else if (MAX_TOTAL_FILE_SIZE_UNIT.toUpperCase() === 'KB') {
        maxSizeInBytes = MAX_TOTAL_FILE_SIZE * 1024;
    } else {
        maxSizeInBytes = MAX_TOTAL_FILE_SIZE * 1024 * 1024; // Default is MB
    }

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
            const totalFileSize = [...selectedForUpload, ...acceptedFiles].reduce((total, file) => total + file.size, 0);

            if (totalFileSize > maxSizeInBytes) {
                toast.error(`Total file size exceeds ${MAX_TOTAL_FILE_SIZE} ${MAX_TOTAL_FILE_SIZE_UNIT} and was not selected.`);
                return;
            }

            setSelectedForUpload((prevFiles) => [...prevFiles, ...acceptedFiles]);
        },
        multiple: true,
        accept: {
            "image/*": [], // jpg, jpeg, png, gif, bmp, tiff, svg, webp, ico, heif, heic, etc.
            "video/*": [], // mp4, avi, mov, wmv, flv, mkv, webm, mpeg, mpg, 3gp, etc.
            "application/pdf": [], // pdf
            "application/msword": [], // doc
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], // docx
            "text/plain": [], // txt, log
            "application/vnd.ms-excel": [], // xls (older Excel format)
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], // xlsx (modern Excel format)
            "text/csv": [] // csv
        },
        disabled: uploading,
    });

    // Handle Delete File
    const deleteFile = async () => {
        if (!fileToDelete) return;

        const { chatId, metadata, file_name } = fileToDelete;
        const documentId = metadata?.documentId;
        setDeleting(true);
        try {
            const response = await DeleteFiles(chatId, documentId);

            if (response) {
                toast.success(`${file_name} deleted successfully`);
                setExistingFiles((prevFiles) => prevFiles.filter(file => file !== fileToDelete));
            } else {
                toast.error("An error occurred while deleting the file");
            }
        } catch (error) {
            setDeleting(false);
            console.error("Error deleting file:", error);
            toast.error("An error occurred while deleting the file");
        } finally {
            setDeleting(false);
            handleClose();
        }
    };




    const handlePreviouslyUploadedClick = (file) => {
        handleFileChangeFromSidebar?.({
            name: file.file_name,
            uri: file.file_uri,
            documentId: file.metadata?.documentId,
        });
        setSelectedDocumentIds(prevIds => [...prevIds, file.metadata?.documentId]);
    };

    const handleClearUploadFile = (fileToRemove) => {
        setSelectedForUpload(prevFiles => prevFiles.filter(file => file.name !== fileToRemove.name));
    };

    const getFileIcon = (fileName) => {
        const extension = fileName.split(".").pop().toLowerCase();
        const icons = {
            jpg: ImageIcon, jpeg: ImageIcon, png: ImageIcon, gif: ImageIcon,
            mp4: VideoLibraryIcon, mov: VideoLibraryIcon, avi: VideoLibraryIcon,
            pdf: DescriptionIcon, doc: DescriptionIcon, docx: DescriptionIcon, txt: DescriptionIcon
        };
        const IconComponent = icons[extension] || InsertDriveFileIcon;
        return <IconComponent className="file-type-icon" />;
    };

    const handleUploadFiles = async () => {
        if (selectedForUpload.length === 0) {
            toast.error("No files selected for upload.");
            return;
        }

        setUploading(true);
        setUploadStatus(prev =>
            Object.fromEntries(selectedForUpload.map(file => [file.name, "uploading"]))
        );

        try {
            const res = await UploadFiles(selectedForUpload, chatId, (fileName, status) => {
                setUploadStatus(prev => ({
                    ...prev,
                    [fileName]: status === "uploaded" ? "uploaded" : "error",
                }));
            });



            const uploadedfiles = res?.uploadedFiles;

            if (Array.isArray(uploadedfiles)) {
                setExistingFiles((prevFiles) => {
                    const fileMap = new Map(prevFiles.map(file => [file.file_name, file])); // Preserve existing files
                    uploadedfiles.forEach(file => fileMap.set(file.file_name, file)); // Append new files
                    return Array.from(fileMap.values());
                });
            }





            // Show success message
            const fileCount = selectedForUpload.length;
            if (fileCount === 1) {
                toast.success(`${selectedForUpload[0].name} uploaded successfully!`);
            } else {
                toast.success(`${fileCount} files uploaded successfully!`);
            }

            setSelectedForUpload([]);
        } catch (error) {
            console.error("Error during file upload:", error);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Drawer anchor="right" open={visible} onClose={onHide} className="custom-drawer-style">
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to delete <strong>{fileToDelete?.file_name}</strong>?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">Cancel</Button>

                    <Button
                        onClick={deleteFile}
                        color="error"
                        autoFocus
                        disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {deleting ? "Deleting..." : "Delete"}
                    </Button>

                </DialogActions>
            </Dialog>
            <Box className="file-upload-sidebar">
                <Box className="file-upload-sidebar-header">
                    <IconButton size="small" onClick={onHide} className="close-button">
                        <CancelIcon fontSize="small" />
                    </IconButton>
                </Box>

                <Box className="section">
                    <Box className="section-header">
                        <Typography variant="subtitle2" fontWeight="bold">Previously Uploaded Files</Typography>
                    </Box>
                    <Box className="section-body">
                        {loading ? (
                            <Loader />
                        ) : existingFiles.length > 0 ? (
                            existingFiles.map((file, index) => (
                                <Box
                                key={index}
                                className="fileCard"
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                p={1} // Adds some padding
                                gap={1} // Adds spacing between elements
                            >
                                {/* Left Side: File Name & Icon */}
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    flex="1"
                                    onClick={() => handlePreviouslyUploadedClick(file)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {getFileIcon(file.file_name)}
                                    <Typography 
                                        variant="body2" 
                                        title={file.file_name} 
                                        sx={{ ml: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "150px" }}
                                    >
                                        {file.file_name.length > 15
                                            ? file.file_name.substring(0, 12) + "..."
                                            : file.file_name}
                                    </Typography>
                                </Box>
                            
                                {/* Right Side: Actions */}
                                <Box display="flex" alignItems="center" gap={1} className="fileAction">
                                    <IconButton
                                        size="small"
                                        onClick={() => window.open(file.file_uri, "_blank")}
                                        sx={{ color: "#333366" }}
                                    >
                                        <VisibilityIcon fontSize="small" />
                                    </IconButton>
                            
                                    {!uploading && (canDelete || file.chatId !== "default") ? (
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={() => handleOpen(file)}
                                            sx={{ color: "#333366", minWidth: "auto", padding: "4px" }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </Button>
                                    ) : (
                                        <div style={{ width: "28px" }} /> // Placeholder for spacing
                                    )}
                                </Box>
                            </Box>
                            
                            ))
                        ) : (
                            <Typography variant="body2" color="textSecondary" className="section-body-text">
                                No files have been uploaded for this chat yet.
                            </Typography>
                        )}
                    </Box>
                </Box>

                <Box className="section">
                    <Box className="section-header">
                        <Typography variant="subtitle2" fontWeight="bold">Files Selected for Upload</Typography>
                    </Box>
                    <Box className="section-body">
                        {selectedForUpload.length > 0 ? (
                            selectedForUpload.map((file, index) => (
                                <Box
                                    key={index}
                                    className={`fileCard ${uploadStatus[file.name] || ""}`}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    {getFileIcon(file.name)}
                                    <Typography variant="body2" title={file.name}>
                                        {file.name.length > 15
                                            ? file.name.substring(0, 12) + "..."
                                            : file.name}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() => handleClearUploadFile(file)}
                                        disabled={uploadStatus[file.name] === "uploading"}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            ))
                        ) : (
                            <Typography variant="body2" color="textSecondary" className="section-body-text">
                                No files selected for upload.
                            </Typography>
                        )}
                    </Box>
                </Box>

                <Box className="file-upload-container">
                    <div {...getRootProps()} className={`dropzone ${uploading ? "disabled" : ""}`}>
                        <input {...getInputProps()} className="dropzone-input" />
                        <Typography>Drag & Drop files here, or click to select</Typography>
                    </div>
                    {selectedForUpload.length > 0 && (
                        <Box display="flex" justifyContent="flex-end" width="100%" mt={2}>
                            <Button
                                variant="outlined"
                                size="small"
                                onClick={handleUploadFiles}
                                startIcon={uploading ? <CircularProgress size={14} /> : <UploadIcon />}
                                disabled={uploading}
                                className="upload-button"
                            >
                                {uploading ? "Uploading..." : "Upload"}
                            </Button>
                        </Box>
                    )}
                </Box>
            </Box>
        </Drawer>
    );
};

export default FileUploadSidebar;